import React, { useImperativeHandle, useState } from 'react'
import { forwardRef } from 'react'
import { isMobile } from 'react-device-detect';
import * as rsuite from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import axios from 'axios'
const Delete = forwardRef((props, ref) => {

    const [ShowModal, setShowModal] = useState(false);
    const [Type, setType] = useState(0);
    const [Id, setId] = useState(General.GuidEmpty);
    const [ShowLoader, setShowLoader] = useState(false);
    useImperativeHandle(ref, () => ({
        Show(Type, Id) {
            setShowModal(true);
            setType(Type);
            setId(Id);
            //--> این کامپوننت یک بار ساخته می شود و از بین نمی رود، پس هر بار
            //--> باز شدن باید از حالت تمیز شروع کند
            setShowLoader(false);
        }
    }))


    const DeleteRecord = (url) => {
        setShowLoader(true);
        var RequestOption = {
            method: 'post',
            url: url,
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                Id: Id
            },
            withCredentials: true
        }

        axios(RequestOption)
            .then(function (res) {
                //--> در هر مسیری اسپینر باید متوقف شود، وگرنه دفعه بعد که پنجره
                //--> باز شود دکمه هنوز غیرفعال است
                setShowLoader(false);
                if (res.data.isSuccess) {
                    General.ShowMsg(Enum.MsgType.success, General.DeleteSuccess());
                    setShowModal(false);
                    props.onSubmit();

                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.DeleteError() + res.data.error);
                    setShowModal(false);
                }
            })
            .catch(error => {
                setShowLoader(false);
                if (error.response) {
                    if (error.response.status === 401) {
                        General.ShowMsg(Enum.MsgType.error, General.unAuthorize());
                    }
                    else if (error.response.status === 403) {
                        General.ShowMsg(Enum.MsgType.error, General.AccessDenied());
                    }
                }
                else {
                    General.ShowMsg(Enum.MsgType.error, General.UnkownException(error));
                }
            })
    }

    const CheckDelete = () => {
        if (Type == Enum.DeleteType.User) {
            DeleteRecord(General.ApiRoute() + "/User/Delete");
        }
        else if (Type == Enum.DeleteType.Project) {
            DeleteRecord(General.ApiRoute() + "/Project/Delete");
        }
        else if (Type == Enum.DeleteType.Category) {
            DeleteRecord(General.ApiRoute() + "/Category/Delete");
        }
        else if (Type == Enum.DeleteType.Company) {
            DeleteRecord(General.ApiRoute() + "/Company/Delete");
        }
        else if (Type == Enum.DeleteType.Topic) {
            DeleteRecord(General.ApiRoute() + "/Topic/Delete");
        }
        else if (Type == Enum.DeleteType.Task) {
            DeleteRecord(General.ApiRoute() + "/Task/Delete");
        }

    }

    return (
        <>
            {
                isMobile ?
                    <rsuite.Drawer open={ShowModal} onClose={() => setShowModal(false)} placement="bottom" size="xs" >
                        <rsuite.Drawer.Header>
                            <rsuite.Drawer.Title>حذف اطلاعات</rsuite.Drawer.Title>

                        </rsuite.Drawer.Header>
                        <rsuite.Drawer.Body>
                            آیا از حذف اطلاعات اطمینان دارید ؟
                            <rsuite.Divider />
                            <div align="left">

                                {
                                    !ShowLoader ?

                                        <rsuite.Button appearance='primary' color="red" className='m-2' onClick={CheckDelete}>
                                            حذف
                                        </rsuite.Button>
                                        :
                                        <rsuite.Button appearance='primary' disabled color="red" className='m-2' onClick={CheckDelete}>
                                            <rsuite.Loader /> منتظر بمانید
                                        </rsuite.Button>

                                }
                                <rsuite.Button appearance='default' className='m-2' onClick={() => setShowModal(false)}>
                                    بستن
                                </rsuite.Button>
                            </div>
                        </rsuite.Drawer.Body>

                    </rsuite.Drawer >
                    :

                    <rsuite.Modal open={ShowModal} onClose={() => setShowModal(false)} size="md">
                        <rsuite.Modal.Header>
                            <rsuite.Modal.Title>جذف اطلاعات</rsuite.Modal.Title>
                        </rsuite.Modal.Header>
                        <rsuite.Modal.Body>
                            آیا از حذف اطلاعات اطمینان دارید ؟
                        </rsuite.Modal.Body>
                        <rsuite.Modal.Footer>
                            {
                                !ShowLoader ?

                                    <rsuite.Button appearance='primary' color="red" className='m-2' onClick={CheckDelete}>
                                        حذف
                                    </rsuite.Button>
                                    :
                                    <rsuite.Button appearance='primary' disabled color="red" className='m-2' onClick={CheckDelete}>
                                        <rsuite.Loader /> منتظر بمانید
                                    </rsuite.Button>

                            }
                            <rsuite.Button appearance='default' className='m-2' onClick={() => setShowModal(false)}>
                                بستن
                            </rsuite.Button>
                        </rsuite.Modal.Footer>
                    </rsuite.Modal>
            }
        </>

    )
});

export default Delete;